<template>
    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
        <div class="flipper">
            <div class="front">
                <img :src="getImagePath(image)" v-if="image !== ''" />
            </div>
            <div class="back">
                <div class="back-content">
                    <a :href="link" :alt="header">
                         <h1 v-text="header"></h1>
                        <h4 v-text="description"></h4>
                    </a> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "flipcard",
    props: {
        image: String,
        link: String,
        header: String,
        description: String,
        text: String
    },
    methods: {
        getImagePath(image) {
            var cdn = this.$store.getters['CONTENTDATA/CDN'];
            return cdn + image;
        }
    }
}
</script>

<style lang="postcss" scoped>

/* entire container, keeps perspective */
.flip-container {
	perspective: 1000px;
    padding-top: 1em;
    width: 33%;
}

.flip-container:hover .flipper, 
.flip-container.hover .flipper {
  transform: rotateY(180deg);
}

.flip-container,
.front,
.back {
    width: 100%;
    height: 100%;
    margin: auto;
    position-top: -200px;
    position: relative;
    z-index: 10000;
}


.flipper {
	transition: 0s;
	transform-style: preserve-3d;
	position: relative;
    width: 460px;
    height: 334px;

}

.front, .back {
	backface-visibility: hidden;
	position: absolute;
	top: 0;
	left: 0;
}


.front {
	z-index: 2;
}


.back {
	transform: rotateY(180deg);
    height: 100%;
}


.back-content {
    margin-top: 25%;
}

h1 { line-height: 25px; text-transform: uppercase; font-size: 1.1em; margin-top: 0; font-family: Didot;}
h4 {
   font-size: 1.6em;
   line-height: 25px;
   font-weight: normal;
   font-family: Didot-Italic;	
}
a,
a:hover {
    color:black;
    text-decoration: none;
}


</style>